import { Injectable } from '@angular/core';
import {
  createController,
  createCardForm,
  createFieldCollectionForm,
  createGooglePay,
  createApplePay,
  RyftInstanceConfig,
  RyftControllerResponse,
  RyftCardFormConfig,
  RyftCardFormComponentResponse,
  RyftFieldCollectionFormConfig,
  RyftFieldCollectionFormComponentResponse,
  RyftGooglePayConfig,
  RyftGooglePayComponentResponse,
  RyftApplePayConfig,
  RyftApplePayComponentResponse,
} from '../models';

/**
 * Thin injectable wrapper around the Ryft Web SDK factory functions.
 *
 * Delegates directly to the underlying SDK but makes the calls
 * mockable in unit tests through Angular's dependency injection.
 */
@Injectable({ providedIn: 'root' })
export class RyftSdkService {
  createController(config: RyftInstanceConfig): RyftControllerResponse {
    return createController(config);
  }

  createCardForm(controller: RyftControllerResponse, config: RyftCardFormConfig): RyftCardFormComponentResponse {
    return createCardForm(controller, config);
  }

  createFieldCollectionForm(
    controller: RyftControllerResponse,
    config: RyftFieldCollectionFormConfig,
  ): RyftFieldCollectionFormComponentResponse {
    return createFieldCollectionForm(controller, config);
  }

  createGooglePay(controller: RyftControllerResponse, config: RyftGooglePayConfig): RyftGooglePayComponentResponse {
    return createGooglePay(controller, config);
  }

  createApplePay(controller: RyftControllerResponse, config: RyftApplePayConfig): RyftApplePayComponentResponse {
    return createApplePay(controller, config);
  }
}
